import { ResolveFn } from '@angular/router';
import { inject } from '@angular/core';
import { HomePageInfoSnapshot, HomePageService } from '../../../services/home-page.service';
import { isNullOrUndefined } from 'in-time-core';
import { ErrorType } from '../../../core/models/error-type';
import { EventSearchService } from '../../../services/event-search.service';

export const homePageResolver: ResolveFn<HomePageInfoSnapshot> = async () => {
  const homePageService = inject(HomePageService);
  const eventSearchService = inject(EventSearchService);

  const results = await Promise.all([
    homePageService.ensureInitialized(),
    eventSearchService.ensureInitialized(),
  ]);

  const homePageResponse = results[0];

  if(!homePageResponse.success) {
    return {
      success: false,
      error: homePageResponse.error,
    };
  }

  const homePageInfo = homePageService.homePageInfo;
  if(isNullOrUndefined(homePageInfo)) {
    return {
      success: false,
      error: ErrorType.Unknown,
    };
  }

  return homePageInfo;
}
